import ICWarning from 'assets/icons/warning-icon.svg'
import CustomButton from 'components/Buttons/CustomButton'
import { useSnackbar } from 'notistack'
import { useEffect, useState } from 'react'
import { AlertCircle } from 'react-feather'
import { useDispatch, useSelector } from 'react-redux'
import { Modal, ModalBody } from 'reactstrap'
import { useDeleteCategoryMutation } from '../payable-notes/payableNotesApiSlice'
import {
  useDeleteCashFlowMutation,
  useDeleteCashFlowPersonalMutation,
  useLazyGetCategoriesCashFlowQuery,
  useLazyGetCategoriesCashFlowPersonalQuery,
} from './cashFlowApiSlice'
import { toggleSidebarCashflow } from './cashFlowSlice'

const ModalDelete = ({
  row,
  isOpen,
  toggle,
  handleFinishedDelete,
  isCategory,
  isIncome,
  isPersonal,
}) => {
  const dispatch = useDispatch()
  const [errMsg, setErrMsg] = useState('')
  const [deleteCashFlow, result] = useDeleteCashFlowMutation()
  const [deleteCashFlowPersonal, resultPersonal] = useDeleteCashFlowPersonalMutation()
  const [deleteCategory, result2] = useDeleteCategoryMutation()
  const [getCategories] = useLazyGetCategoriesCashFlowQuery()
  const [getCategoriesPersonal] = useLazyGetCategoriesCashFlowPersonalQuery()
  const { ownerData } = useSelector((s) => s.dashboard)
  const { enqueueSnackbar } = useSnackbar()

  const handleSubmit = async () => {
    try {
      let body = {}
      if (!isCategory) {
        body = {
          type: row?.type,
          offlineID: row?.offlineID,
        }
      } else {
        body = {
          id: row?.id,
        }
      }
      const resp = await (
        !isCategory
          ? (isPersonal ? deleteCashFlowPersonal(body) : deleteCashFlow(body))
          : deleteCategory(body)
      ).unwrap()
      if (!resp?.data?.error) {
        enqueueSnackbar('Berhasil menghapus catatan manual', {
          variant: 'success',
        })
        toggle()
        if (!isCategory) {
          dispatch(toggleSidebarCashflow())
          handleFinishedDelete()
        } else {
          const getCategoriesFn = isPersonal ? getCategoriesPersonal : getCategories
          getCategoriesFn({
            type: isIncome ? 'income' : 'expense',
            active: 1,
            userId: ownerData?.userId,
          })
        }
      } else {
        throw resp
      }
    } catch (error) {
      enqueueSnackbar(error?.data?.message ?? error?.message, {
        variant: 'error',
      })
      setErrMsg(error?.data?.message ?? error?.message)
    }
  }

  useEffect(() => {
    if (!isOpen) {
      setErrMsg('')
    }
  }, [isOpen])

  return (
    <Modal centered toggle={toggle} isOpen={isOpen}>
      <ModalBody>
        <img src={ICWarning} alt="Warning Icon" />
        <h6 className="mt-4 fw-600">
          Hapus {isCategory ? 'kategori ini?' : 'catat manual'}
        </h6>
        <span>
          {!isCategory
            ? ' Apakah kamu yakin ingin menghapus pencatatan ini?. Jika kamu menghapus pencatatan ini, maka pencatatan akan hilang dan tidak bisa dikembalikan lagi.'
            : ''}
        </span>
        {errMsg && (
          <small className="text-danger">
            <AlertCircle size={15} /> {errMsg}
          </small>
        )}
        <div className="d-flex gap-3 mt-4">
          <CustomButton onClick={toggle} block outline className="btn-cancel">
            Batal
          </CustomButton>
          <CustomButton
            onClick={handleSubmit}
            disabled={result?.isLoading || result2?.isLoading || resultPersonal?.isLoading}
            block
            color="danger"
          >
            Hapus
          </CustomButton>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ModalDelete
